import type { ActionStatus } from '../services/autopilotService';

/**
 * Action statuses still waiting for the user's decision (approve or ignore).
 *
 * Both 'ready' and 'generated' count. The backend treats both as open (insights
 * return only these two; approving accepts either), and every action surface
 * (Autopilot cards, the action preview, mobile) offers Approve/Ignore for both.
 * The bell used to count 'ready' only, so it could say fewer than the Radar and
 * the Autopilot page it links to (WB-122). One rule for every such count.
 */
export const AWAITING_DECISION_ACTION_STATUSES: ReadonlySet<ActionStatus> = new Set<ActionStatus>(['ready', 'generated']);

/** True when the action still waits for the user to approve or ignore it. */
export function isActionAwaitingDecision(action: { status?: string | null } | null | undefined): boolean {
  return !!action?.status && AWAITING_DECISION_ACTION_STATUSES.has(action.status as ActionStatus);
}
